import Link from 'next/link'
import type { ReactNode } from 'react'
import { cn } from '@/atoms/lib/utils'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle
} from '@/atoms/components/ui/navigation-menu'
import { navigationConfig, type NavItem } from '@/data/inc/navigation'
import { MarketplaceMenu } from './TalentMarketeplace'
import { SolutionsMenu } from './SolutionsMenu'
import { ResourcesMenu } from './ResourcesMenu'

export const DesktopNav = () => {
  return (
    <NavigationMenu className="hidden md:block sticky top-0 z-50">
      <div className="mx-auto px-8 md:px-[8%] py-4 bg-white">
        <div className="grid grid-cols-[auto_1fr_auto] place-items-center max-w-7xl mx-auto">
          <Link href="/">
            <img alt="" src="/assets/inc/nav/logo.svg" className="h-8" />
          </Link>

          <NavigationMenuList className="flex gap-2">
            {navigationConfig.map(item => (
              <NavigationMenuItem key={item.label}>
                {item.hasDropdown ? (
                  <>
                    <NavigationMenuTrigger className="py-2 px-4">
                      {item.label}
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      {renderMenuContent(item)}
                    </NavigationMenuContent>
                  </>
                ) : (
                  <Link
                    href={item.href || '#'}
                    className={cn(navigationMenuTriggerStyle(), 'py-2 px-4')}
                  >
                    {item.label}
                  </Link>
                )}
              </NavigationMenuItem>
            ))}
          </NavigationMenuList>

          <div className="flex items-center gap-4 text-base">
            <Link
              href="/login"
              className="border border-[#060135] rounded-full uppercase text-base font-medium text-[#060135]  px-4 py-2"
            >
              Login
            </Link>
            <Link
              href="/contact-us"
              className="bg-[#060135] rounded-full uppercase text-base font-medium text-white px-4 py-2"
            >
              Book A Demo
            </Link>
          </div>
        </div>
      </div>
    </NavigationMenu>
  )
}

const renderMenuContent = (item: NavItem) => {
  switch (item.label) {
    case 'Solutions':
      return <SolutionsMenu />
    case 'Resources':
      return <ResourcesMenu />
    case 'Talent Marketplace':
      return <MarketplaceMenu />
    default:
      return <></>
  }
}

export const MenuShell = ({ children }: { children: ReactNode }) => {
  return (
    <div className="w-screen p-8 bg-[#0D007D] text-[#CAD5E2]">
      <div className="max-w-7xl mx-auto">{children}</div>
    </div>
  )
}
